"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconUser = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconUser = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75C9.92897 3.75 8.25004 5.42893 8.25004 7.5C8.25004 9.57107 9.92897 11.25 12 11.25C14.0711 11.25 15.75 9.57107 15.75 7.5C15.75 5.42893 14.0711 3.75 12 3.75ZM6.75004 7.5C6.75004 4.6005 9.10055 2.25 12 2.25C14.8995 2.25 17.25 4.6005 17.25 7.5C17.25 10.3995 14.8995 12.75 12 12.75C9.10055 12.75 6.75004 10.3995 6.75004 7.5ZM9.35703 14.75C9.40406 14.75 9.45172 14.75 9.50005 14.75H14.5C14.5484 14.75 14.596 14.75 14.643 14.75C15.9012 14.7497 16.7031 14.7495 17.3789 14.9545C18.897 15.415 20.085 16.603 20.5455 18.1211C20.7505 18.797 20.7503 19.5989 20.7501 20.857C20.7501 20.904 20.75 20.9517 20.75 21C20.75 21.4142 20.4143 21.75 20 21.75C19.5858 21.75 19.25 21.4142 19.25 21C19.25 19.5499 19.2419 18.9911 19.1101 18.5566C18.795 17.5179 17.9822 16.705 16.9435 16.3899C16.509 16.2581 15.9502 16.25 14.5 16.25H9.50005C8.04991 16.25 7.49111 16.2581 7.05661 16.3899C6.01791 16.705 5.20507 17.5179 4.88999 18.5566C4.75818 18.9911 4.75004 19.5499 4.75004 21C4.75004 21.4142 4.41425 21.75 4.00004 21.75C3.58583 21.75 3.25004 21.4142 3.25004 21C3.25004 20.9517 3.25003 20.904 3.25002 20.857C3.24974 19.5989 3.24956 18.797 3.45458 18.1211C3.91509 16.603 5.10308 15.415 6.62119 14.9545C7.29702 14.7495 8.09892 14.7497 9.35703 14.75Z",
    fill: color
  }))));
};
exports.IconUser = IconUser;
//# sourceMappingURL=IconUser.js.map